import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "flow-geo-map",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description:
      "A three-stage flow graph correlated with a world map of its endpoints, with hover/click highlighting shared between both.",
    domain: "reports",
    visual: "Map",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  defaultLayoutClassName: "col-span-12",
};
